import { VStack } from '@cbhq/cds-web/layout';
import { Text } from '@cbhq/cds-web/typography/Text';
import { defineMessages, useIntl } from '@cbhq/i18n';

const messages = defineMessages({
  title: {
    id: 'Security.approvalRules.title',
    defaultMessage: 'Approval rules',
    description: 'Title for the workspace Approval rules page',
  },
});

export function ApprovalRulesPage() {
  const { formatMessage } = useIntl();

  return (
    <VStack gap={4} width="100%" data-testid="approval-rules-page">
      <Text as="h1" font="title1">
        {formatMessage(messages.title)}
      </Text>
    </VStack>
  );
}
